
import { Link } from "react-router-dom";
import styled from "styled-components";

import { btnReset, v } from "./variables";

export const SSidebar = styled.div`
    width: ${({ isOpen }) => (!isOpen ? `55px` : v.sidebarWidth)};
    background:  #0072bb;
    height: 100vh;

    padding: ${v.lgSpacing};
    transition: ease-in-out 0.2s;
    
    
   
`;

export const SSidebarButton = styled.button`
    ${btnReset};
 
    padding: 0px 16px !important;
    cursor: pointer;

    color: white;

`;

export const SLogo = styled.div`
    width: 52px;

    img {
        max-width: 100%;
        height: auto;
    }
    cursor: pointer;

    margin-bottom: ${v.lgSpacing};
`;

export const SSearch = styled.div`
    background: ${({ theme }) => theme.bgAlpha};
    // border: 1px solid ${({ theme }) => theme.bg3};
    border-radius: ${v.borderRadius};
    color: white;
    input {
        padding: 0 ${v.smSpacing};
        font-family: inherit;
        letter-spacing: inherit;
        font-size: 16px;
        width: 100%;
        outline: none;
        border: none;
        color: inherit;
        background: transparent;
    }
    display: flex;
`;

export const SSearchIcon = styled.button`
    ${btnReset};
    padding: calc(${v.mdSpacing} - 2px) ${v.mdSpacing};
    display: flex;
    cursor: pointer;
    color:white;
    svg {
        font-size: 20px;
    }
`;

export const SDivider = styled.div`
    height: 1px;
    width: 100%;
    color:white;
    background: ${({ theme }) => theme.bg3};
    margin: ${v.lgSpacing} 0;
`;

export const SLinkContainer = styled.div`
    background: ${({ theme, isActive }) => (!isActive ? `transparent` : theme.bg3)};
    border-radius: ${v.borderRadius};
    margin: 8px 0;
    color:white;
border:  ${({ theme, isActive }) => (!isActive ? `transparent` : `1px solid white`)};
   
:hover{
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.bg3};
    
}


`;

export const SLink = styled(Link)`
    display: flex;
    align-items: center;
    text-decoration: none;
    color: white;
    font-size: 16px;
    padding: calc(${v.smSpacing} - 10px) 0;
`;

export const SLinkIcon = styled.div`

    padding: ${v.mdSpacing} ${v.mdSpacing};
    display: flex;
    color:white;
    

    svg {
        font-size: 20px;
    }
`;

export const SLinkLabel = styled.span`
white-space: pre;
 
    display: block;
    flex: 1;
    color:white;
    margin-left: ${v.smSpacing};
`;

export const SLinkNotification = styled.div`
    font-size: 14px;
    padding: calc(${v.smSpacing} / 2) ${v.smSpacing};
    border-radius: calc(${v.borderRadius} / 2);
    background: ${({ theme }) => theme.primary};
    color: white;

    margin-right: ${v.mdSpacing};
`;

export const STheme = styled.div`
    display: flex;
    align-items: center;
    font-size: 16px;
    color:white;
`;
export const SThemeLabel = styled.span`
    display: block;
    flex: 1;
    
`;
export const SThemeToggler = styled.button`
    ${btnReset};
    margin: 0 auto;
    cursor: pointer;
    width: 36px;
    height: 20px;
    border-radius: 10px;
    background: ${({ theme, isActive }) => (!isActive ? theme.bg3 : theme.primary)};

`;

export const SToggleThumb = styled.div`
    height: 18px;
    width: 18px;
   
    top: 1px;
    bottom: 1px;
    transition: 0.2s ease right;
    right: calc(100% - 18px - 1px);
    border-radius: 50%;
    background: ${({ theme }) => theme.bg};
`;